import { render, staticRenderFns } from "./ContactPhoneEdit.vue?vue&type=template&id=42faa4b4&"
import script from "./ContactPhoneEdit.vue?vue&type=script&lang=js&"
export * from "./ContactPhoneEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports